import React, { useState, useEffect, useRef } from 'react';

// Proveedores de juegos (mismos de VG y XG)
const gameProviders = [
  { name: 'PG', fullName: 'PG Soft', color: '#F59E0B', logo: '/providers/pg-soft.png' },
  { name: 'PP', fullName: 'Pragmatic Play', color: '#3B82F6', logo: '/providers/pragmatic-play.png' },
  { name: 'Spirit', fullName: 'Spirit Gaming', color: '#8B5CF6', logo: '/providers/spirit.png' },
  { name: 'Tada', fullName: 'Tada Gaming', color: '#EC4899', logo: '/providers/tada.png' },
  { name: 'Reeveme', fullName: 'Reeveme', color: '#10B981', logo: '/providers/reeveme.png' },
  { name: 'FC', fullName: 'FA CHAI', color: '#3B5998', logo: '/providers/fachai.png' },
  { name: 'MG', fullName: 'Micro Gaming', color: '#10B981', logo: '/providers/microgaming.png' }
];

const responsibilityBadges = [
  { name: 'Juego Responsable', icon: 'RG' },
  { name: 'GamCare', icon: 'GC' },
  { name: 'BetBlocker', icon: 'BB' },
  { name: '18+', icon: '18+' }
];

const PlatformSelector = ({ onPlatformSelect }) => {
  const [accuracy, setAccuracy] = useState(() => parseFloat((85 + Math.random() * 10).toFixed(1)));
  const [isVisible, setIsVisible] = useState(false);
  const [heroVisible, setHeroVisible] = useState(false);
  const [cardsVisible, setCardsVisible] = useState(false);
  const [ctaVisible, setCtaVisible] = useState(false);
  const [footerVisible, setFooterVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const footerRef = useRef(null);
  const coreRef = useRef(null);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
    setTimeout(() => setHeroVisible(true), 300);
    setTimeout(() => setCardsVisible(true), 700);
    setTimeout(() => setCtaVisible(true), 1000);

    const accuracyInterval = setInterval(() => {
      setAccuracy(prev => {
        const change = (Math.random() - 0.5) * 0.8;
        return Math.min(99, Math.max(80, parseFloat((prev + change).toFixed(1))));
      });
    }, 3000);

    const handleMouseMove = (e) => {
      if (!coreRef.current) return;
      const rect = coreRef.current.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      const x = ((e.clientX - centerX) / (window.innerWidth / 2)) * 6;
      const y = ((e.clientY - centerY) / (window.innerHeight / 2)) * 6;
      setMousePosition({ x: Math.max(-6, Math.min(6, x)), y: Math.max(-6, Math.min(6, y)) });
    };

    window.addEventListener('mousemove', handleMouseMove);

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setFooterVisible(true);
    }, { threshold: 0.2 });
    if (footerRef.current) observer.observe(footerRef.current);

    return () => {
      clearInterval(accuracyInterval);
      window.removeEventListener('mousemove', handleMouseMove);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0603] text-white overflow-x-hidden">

      {/* ═══════ FONDO ANIMADO OCBET (naranja/ámbar) ═══════ */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute inset-0"
          style={{ background: 'radial-gradient(ellipse at 50% 30%, #3a1a05 0%, #1f0f04 35%, #120902 70%, #0a0603 100%)' }}
        />
        <div
          className="absolute top-[-300px] right-[-200px] w-[900px] h-[900px] rounded-full animate-glow-pulse"
          style={{ background: 'radial-gradient(circle, rgba(249, 115, 22, 0.20) 0%, rgba(249, 115, 22, 0.08) 30%, transparent 60%)', filter: 'blur(80px)' }}
        />
        <div
          className="absolute bottom-[-300px] left-[-200px] w-[800px] h-[800px] rounded-full animate-glow-pulse-delay"
          style={{ background: 'radial-gradient(circle, rgba(245, 158, 11, 0.15) 0%, rgba(245, 158, 11, 0.06) 30%, transparent 60%)', filter: 'blur(80px)' }}
        />
        <div
          className="absolute top-[40%] left-[20%] w-[600px] h-[600px] rounded-full animate-nebula-drift"
          style={{ background: 'radial-gradient(circle, rgba(234, 88, 12, 0.10) 0%, transparent 60%)', filter: 'blur(60px)' }}
        />
        {[...Array(70)].map((_, i) => (
          <div
            key={`star-${i}`}
            className="absolute rounded-full animate-twinkle"
            style={{
              width: `${1 + Math.random() * 2}px`,
              height: `${1 + Math.random() * 2}px`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              background: i % 4 === 0 ? '#fdba74' : i % 4 === 1 ? '#fbbf24' : i % 4 === 2 ? '#fb923c' : '#ffffff',
              boxShadow: `0 0 ${2 + Math.random() * 4}px currentColor`,
              opacity: 0.4 + Math.random() * 0.4,
              animationDelay: `${Math.random() * 6}s`,
              animationDuration: `${2 + Math.random() * 4}s`,
            }}
          />
        ))}
        {[...Array(3)].map((_, i) => (
          <div
            key={`comet-${i}`}
            className="absolute animate-shooting-star"
            style={{
              top: `${10 + i * 25}%`,
              left: '-10%',
              width: '120px',
              height: '1px',
              background: 'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.8) 50%, rgba(249, 115, 22, 0.6) 80%, transparent 100%)',
              animationDelay: `${i * 4 + Math.random() * 3}s`,
              animationDuration: `${6 + i}s`,
            }}
          />
        ))}
      </div>

      <div className="relative z-10">

        {/* HEADER */}
        <header className={`py-4 px-4 sm:px-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}>
          <div className="max-w-7xl mx-auto flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-lg bg-[#140c04] border border-orange-500/30 flex items-center justify-center p-1">
                <img src="/assets/ocbet/ocbet-emblem.png" alt="OCBET" className="w-full h-full object-contain" />
              </div>
              <span className="text-lg font-black tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-400">OCBET</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm">
              <div className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
              <span className="text-xs sm:text-sm text-gray-400">En línea</span>
            </div>
          </div>
        </header>

        {/* HERO */}
        <main className="px-4 sm:px-6 py-6 sm:py-8">
          <div className="max-w-7xl mx-auto">

            <div className="flex flex-col items-center justify-center min-h-[26vh] sm:min-h-[30vh] mb-6 sm:mb-8">
              <div
                ref={coreRef}
                className={`relative w-[170px] h-[170px] sm:w-[210px] sm:h-[210px] lg:w-[240px] lg:h-[240px] transition-all duration-1000 ${heroVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}
                style={{
                  transform: `perspective(1000px) rotateX(${-mousePosition.y * 0.5}deg) rotateY(${mousePosition.x * 0.5}deg)`,
                  transition: 'transform 0.15s ease-out'
                }}
              >
                {/* Aura */}
                <div
                  className="absolute inset-[-40px] rounded-full pointer-events-none animate-glow-pulse"
                  style={{ background: 'radial-gradient(circle, rgba(249, 115, 22, 0.28) 0%, rgba(245, 158, 11, 0.12) 35%, transparent 65%)', filter: 'blur(45px)' }}
                />
                {/* Anillos radar */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="absolute w-[180px] h-[180px] sm:w-[220px] sm:h-[220px] lg:w-[250px] lg:h-[250px] rounded-full animate-radar-ring-1" style={{ border: '1.5px solid rgba(249, 115, 22, 0.35)', boxShadow: '0 0 30px rgba(249, 115, 22, 0.25)' }} />
                  <div className="absolute w-[140px] h-[140px] sm:w-[170px] sm:h-[170px] lg:w-[195px] lg:h-[195px] rounded-full animate-radar-ring-2" style={{ border: '1px solid rgba(251, 191, 36, 0.3)', boxShadow: '0 0 25px rgba(245, 158, 11, 0.18)' }} />
                  {/* Emblema */}
                  <img
                    src="/assets/ocbet/ocbet-emblem.png"
                    alt="OCBET"
                    draggable={false}
                    className="relative w-[125px] h-[125px] sm:w-[155px] sm:h-[155px] lg:w-[180px] lg:h-[180px] object-contain animate-emblem-float"
                    style={{ filter: 'drop-shadow(0 0 22px rgba(249, 115, 22, 0.75)) drop-shadow(0 0 44px rgba(245, 158, 11, 0.4))' }}
                  />
                </div>
              </div>

              <p className={`mt-6 sm:mt-8 text-gray-400 text-xs sm:text-sm text-center transition-all duration-700 delay-300 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-400 font-bold tracking-wider">OCBET</span>
                <span className="mx-2 text-gray-600">·</span>
                Inteligencia de señales de alta precisión
              </p>
            </div>

            {/* SEÑALES EN VIVO + PROVEEDORES */}
            <div className={`space-y-4 transition-all duration-700 ${cardsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <div className="flex items-center justify-center mb-4">
                <div className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-emerald-500/10 border border-emerald-500/30">
                  <div className="w-2.5 h-2.5 rounded-full bg-emerald-400 animate-pulse" />
                  <span className="text-emerald-400 font-bold text-sm tracking-wide">SEÑALES EN VIVO</span>
                </div>
              </div>

              <div className="max-w-4xl mx-auto">
                <div className="grid grid-cols-4 sm:grid-cols-8 gap-2.5 sm:gap-3">
                  {gameProviders.map((provider) => (
                    <div key={provider.name} className="group relative min-h-[92px] transition-all duration-300 hover:translate-y-[-3px]">
                      <div
                        className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-50 transition-all duration-300"
                        style={{ background: `radial-gradient(circle, ${provider.color}30 0%, transparent 70%)`, filter: 'blur(12px)' }}
                      />
                      <div className="relative h-full rounded-xl bg-[#140c04]/80 border border-white/5 group-hover:border-orange-400/25 backdrop-blur-sm p-3 flex flex-col items-center justify-center transition-all duration-300 overflow-hidden">
                        <div className="w-14 h-14 flex items-center justify-center mb-1.5 transition-transform group-hover:scale-110">
                          {provider.logo ? (
                            <img src={provider.logo} alt={provider.fullName} className="w-full h-full object-contain" />
                          ) : (
                            <span className="text-sm font-bold text-white">{provider.name}</span>
                          )}
                        </div>
                        <span className="text-[9px] text-gray-500 group-hover:text-gray-400 transition-colors text-center leading-tight">{provider.fullName}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Indicador de precisión */}
              <div className="w-full max-w-4xl mx-auto">
                <div className="rounded-xl bg-[#140c04]/80 border border-white/5 backdrop-blur-sm p-4 sm:p-5 hover:border-orange-400/15 transition-all relative overflow-hidden">
                  <div className="relative flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-4">
                    <div>
                      <h3 className="text-2xl sm:text-3xl lg:text-4xl font-black text-white">
                        200<span className="text-orange-400">+</span>
                      </h3>
                      <p className="text-gray-500 text-xs uppercase tracking-wider mt-1">Juegos disponibles</p>
                    </div>

                    <div className="flex items-center gap-4 sm:gap-6">
                      <div className="text-left sm:text-right">
                        <p className="text-[10px] text-gray-600 uppercase tracking-wider mb-0.5">Tasa de acierto</p>
                        <p className="text-2xl sm:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-400 transition-all duration-700">
                          {accuracy}%
                        </p>
                      </div>
                      <div className="flex items-center gap-1.5 px-3 py-2 rounded-full bg-emerald-500/15 border border-emerald-500/30">
                        <div className="w-2.5 h-2.5 rounded-full bg-emerald-400 animate-pulse" />
                        <span className="text-xs text-emerald-400 font-bold">En vivo</span>
                      </div>
                    </div>
                  </div>

                  <div className="relative h-3 sm:h-4 rounded-full bg-white/5 overflow-hidden">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-orange-500 via-amber-400 to-orange-500 relative transition-all duration-1000"
                      style={{ width: `${accuracy}%`, boxShadow: '0 0 20px rgba(249, 115, 22, 0.4)' }}
                    >
                      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-white animate-pulse" style={{ boxShadow: '0 0 10px rgba(255,255,255,0.8), 0 0 20px rgba(249, 115, 22, 0.6)' }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA - OCBET (plataforma única) */}
            <div className={`mt-6 sm:mt-8 transition-all duration-700 delay-200 ${ctaVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <h2 className="text-center text-xl sm:text-2xl font-bold text-white mb-6">Tu plataforma</h2>

              <div className="max-w-sm mx-auto px-4">
                <div className="relative w-full">
                  <div className="absolute -inset-4 rounded-3xl animate-breathing-glow pointer-events-none" style={{
                    background: 'radial-gradient(ellipse at center, rgba(249, 115, 22, 0.35) 0%, transparent 70%)',
                    filter: 'blur(22px)'
                  }} />

                  <button
                    onClick={() => onPlatformSelect('OCBET')}
                    data-testid="platform-select-ocbet-btn"
                    className="w-full block group relative"
                  >
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-20 flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-[11px] font-black tracking-wider whitespace-nowrap animate-recommended-pulse" style={{
                      background: 'linear-gradient(135deg, #f97316 0%, #f59e0b 50%, #fbbf24 100%)',
                      boxShadow: '0 4px 12px rgba(249, 115, 22, 0.5), 0 0 20px rgba(245, 158, 11, 0.45), inset 0 1px 0 rgba(255,255,255,0.4)',
                      color: '#3a1a05'
                    }} data-testid="ocbet-official-badge">
                      <span>★ PLATAFORMA OFICIAL ★</span>
                    </div>

                    <div className="absolute -inset-[2px] rounded-2xl animate-cta-breathing-border" style={{
                      background: 'conic-gradient(from 0deg, #f97316, #fbbf24, #ea580c, #f97316)',
                    }} />

                    <div className="relative rounded-2xl bg-gradient-to-br from-[#1a0f04] to-[#0e0803] p-6 border border-orange-500/30 group-hover:border-orange-400/60 transition-all duration-300 group-hover:translate-y-[-4px] group-hover:shadow-xl group-hover:shadow-orange-500/30 overflow-hidden">
                      <div className="relative flex flex-col items-center text-center">
                        <div className="relative mb-4">
                          <div className="absolute -inset-3 rounded-2xl animate-breathing-glow pointer-events-none" style={{
                            background: 'radial-gradient(circle, rgba(249, 115, 22, 0.5) 0%, rgba(245, 158, 11, 0.28) 45%, transparent 75%)',
                            filter: 'blur(16px)'
                          }} />
                          <div className="relative w-36 h-36 sm:w-40 sm:h-40 rounded-2xl overflow-hidden bg-[#140c04] border border-orange-400/40 shadow-[0_0_30px_rgba(249,115,22,0.4)] group-hover:shadow-[0_0_45px_rgba(249,115,22,0.7)] transition-all duration-300 flex items-center justify-center p-3">
                            <img src="/assets/ocbet/ocbet-emblem.png" alt="OCBET" className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500" />
                          </div>
                        </div>

                        <h3 className="text-2xl sm:text-3xl font-black mb-1 tracking-wider">
                          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-300">OCBET</span>
                        </h3>

                        <p className="text-[11px] text-orange-300/80 tracking-wider mb-3">
                          <span className="text-amber-400">✦</span> Casino & Slots · México <span className="text-amber-400">✦</span>
                        </p>

                        <span className="w-full py-3 px-6 rounded-lg text-base font-bold flex items-center justify-center gap-2 text-white" style={{
                          background: 'linear-gradient(135deg, rgba(249, 115, 22, 0.45) 0%, rgba(234, 88, 12, 0.45) 100%)',
                          border: '1px solid rgba(249, 115, 22, 0.5)'
                        }}>
                          <span>ENTRAR</span>
                          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-center gap-2 text-xs text-gray-500 mt-6">
                <div className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                <span>Entorno seguro • Alto rendimiento • En línea 24h</span>
              </div>
            </div>
          </div>
        </main>

        {/* FOOTER */}
        <footer ref={footerRef} className={`mt-12 sm:mt-16 bg-[#0e0803] border-t border-white/5 transition-all duration-700 ${footerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="py-5 sm:py-6 border-b border-white/5 bg-[#120902]">
            <div className="max-w-7xl mx-auto px-2 sm:px-6">
              <div className="flex items-center justify-between sm:justify-center gap-2 sm:gap-10">
                {responsibilityBadges.map((b, idx) => (
                  <div
                    key={b.name}
                    className={`flex items-center gap-1 sm:gap-3 text-gray-400 transition-all duration-500 hover:text-gray-300 ${footerVisible ? 'opacity-100' : 'opacity-0'}`}
                    style={{ transitionDelay: `${idx * 100}ms` }}
                  >
                    <div className="w-7 h-7 sm:w-10 sm:h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-[8px] sm:text-xs font-bold flex-shrink-0">
                      {b.icon}
                    </div>
                    <span className="text-[8px] sm:text-sm font-bold whitespace-nowrap">{b.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="py-5 border-b border-white/5 bg-[#100801]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
              <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-5 mb-3">
                {gameProviders.map((p, idx) => (
                  <div
                    key={`f-${p.name}`}
                    className={`w-14 h-14 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-105 hover:brightness-125 overflow-hidden ${footerVisible ? 'opacity-100' : 'opacity-0'}`}
                    style={{ transitionDelay: `${200 + idx * 80}ms` }}
                  >
                    {p.logo ? (
                      <img src={p.logo} alt={p.fullName} className="w-full h-full object-contain" />
                    ) : (
                      <span className="text-xs font-bold text-gray-400">{p.name}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-center text-xs text-gray-600 italic">
                Se agregan nuevos proveedores constantemente...
              </p>
            </div>
          </div>

          <div className="py-3 px-4 sm:px-6 border-t border-white/5">
            <div className="max-w-7xl mx-auto flex items-center justify-between text-xs text-gray-600">
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 rounded-lg overflow-hidden border border-orange-500/40 bg-[#140c04] flex-shrink-0 flex items-center justify-center p-1">
                  <img src="/assets/ocbet/ocbet-emblem.png" alt="OCBET" className="w-full h-full object-contain" />
                </div>
                <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-400 tracking-wider">OCBET</span>
                <span className="ml-1">© 2026</span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                <span className="hidden sm:inline">Todo funcionando</span>
                <span className="sm:hidden">En línea</span>
              </div>
            </div>
          </div>
        </footer>
      </div>

      {/* ANIMACIONES */}
      <style>{`
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }

        @keyframes twinkle {
          0%, 100% { opacity: 0.2; transform: scale(0.8); }
          50% { opacity: 1; transform: scale(1.2); }
        }
        .animate-twinkle { animation: twinkle 3s ease-in-out infinite; }

        @keyframes emblem-float {
          0%, 100% { transform: translateY(0) rotate(-2deg); }
          50% { transform: translateY(-12px) rotate(2deg); }
        }
        .animate-emblem-float { animation: emblem-float 5s ease-in-out infinite; }

        @keyframes glow-pulse {
          0%, 100% { opacity: 0.6; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.06); }
        }
        .animate-glow-pulse { animation: glow-pulse 6s ease-in-out infinite; }
        .animate-glow-pulse-delay { animation: glow-pulse 7s ease-in-out infinite 1.5s; }

        @keyframes nebula-drift {
          0%, 100% { transform: translate(0, 0) scale(1); opacity: 0.6; }
          33% { transform: translate(40px, -30px) scale(1.05); opacity: 0.8; }
          66% { transform: translate(-30px, 40px) scale(0.95); opacity: 0.5; }
        }
        .animate-nebula-drift { animation: nebula-drift 20s ease-in-out infinite; }

        @keyframes shooting-star {
          0% { transform: translateX(-100%) translateY(0) rotate(15deg); opacity: 0; }
          10% { opacity: 1; }
          50% { opacity: 1; }
          100% { transform: translateX(2000px) translateY(400px) rotate(15deg); opacity: 0; }
        }
        .animate-shooting-star { animation: shooting-star 8s linear infinite; }

        @keyframes radar-ring {
          0% { transform: scale(0.85); opacity: 0.6; }
          100% { transform: scale(1.15); opacity: 0; }
        }
        .animate-radar-ring-1 { animation: radar-ring 4s ease-out infinite; }
        .animate-radar-ring-2 { animation: radar-ring 4s ease-out infinite 1.2s; }

        @keyframes breathing-glow {
          0%, 100% { opacity: 0.6; }
          50% { opacity: 1; }
        }
        .animate-breathing-glow { animation: breathing-glow 3s ease-in-out infinite; }

        @keyframes cta-breathing-border {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 0.9; }
        }
        .animate-cta-breathing-border { animation: cta-breathing-border 2.5s ease-in-out infinite; }

        @keyframes recommended-pulse {
          0%, 100% { transform: translateX(-50%) scale(1); }
          50% { transform: translateX(-50%) scale(1.05); }
        }
        .animate-recommended-pulse { animation: recommended-pulse 2s ease-in-out infinite; }
      `}</style>
    </div>
  );
};

export default PlatformSelector;
